import React from "react";
import styled, { css } from "styled-components";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import GA4Event from "@analytics/GoogleAnalytics/GA4Event";
import * as GA4Service from "@analytics/GoogleAnalytics/GA4Service";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { DropdownMenuComponents } from "@common/LifeAtDropdownMenuV2/DropdownMenuComponents";
import MoreActionsIcon from "@icons/Menu-TripleVerticalDots-Icon.svg";
import { BrowserUtil } from "@util/index";
import { ResetWidgetsEvent, ToggleWidgetEvent } from "../../AmplitudeWidgetToolbarEvents";

const StyledMoreActionsIcon = styled(MoreActionsIcon)<{ rotateHorizontal?: boolean }>`
    fill: ${(props) => props.theme.iconColor};
    vertical-align: baseline !important;

    ${({ rotateHorizontal }) =>
        rotateHorizontal &&
        css`
            transform: rotate(90deg);
        `}
`;

const RESET_WIDGET_LAYOUT_LABEL = "Reset Layout";
const RESET_WIDGET_LAYOUT_CONFIRMATION_MSG =
    "Resetting your widget layout will refresh the tab, are you sure you want to continue?";

interface ToolbarSettingsProps {
    readonly closeAndResetAllWidgets: () => void;
    readonly horizontalButton?: boolean;
}
export default function ToolbarSettings(props: ToolbarSettingsProps) {
    const amplitudeService = AmplitudeService.getInstance();

    const handleReset = () => {
        if (confirm(RESET_WIDGET_LAYOUT_CONFIRMATION_MSG)) {
            // Log events first, before page reloads
            GA4Service.logEvent(GA4Event.RESET_WIDGETS);
            amplitudeService.logEvent(new ResetWidgetsEvent(ToggleWidgetEvent.SOURCES.TOOLBAR));

            // Do the reset (also clears the localstorage value)
            props.closeAndResetAllWidgets();

            // Reload the page, so it reloads with the cleared localstorage for the widget layout.
            setTimeout(() => BrowserUtil.reloadPage(), 100);
        }
    };

    return (
        <DropdownMenuComponents.Root>
            <DropdownMenuComponents.Trigger>
                <LifeAtButtonV2 variant={"ghost"} size={"large"} shape={"square"}>
                    <StyledMoreActionsIcon rotateHorizontal={props.horizontalButton} />
                </LifeAtButtonV2>
            </DropdownMenuComponents.Trigger>
            <DropdownMenuComponents.Content>
                <DropdownMenuComponents.Item onClick={handleReset}>
                    {RESET_WIDGET_LAYOUT_LABEL}
                </DropdownMenuComponents.Item>
            </DropdownMenuComponents.Content>
        </DropdownMenuComponents.Root>
    );
}
